import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

export type UnreadInboxPreviewRow = {
  conversation_id: string;
  channel: string;
  integration_id: string | null;
  unread_count: number;
  last_message_at: string | null;
  last_message_preview: string | null;
  last_message_direction: string | null;
  external_user_id: string | null;
  lead_name: string | null;
  lead_phone: string | null;
  lead_metadata: Record<string, unknown> | null;
};

export async function fetchWorkspaceUnreadInboxPreviews(
  supabase: SupabaseClient<Database>,
  workspaceId: string,
): Promise<UnreadInboxPreviewRow[]> {
  const { data, error } = await supabase.rpc("get_workspace_unread_inbox_previews", {
    p_workspace_id: workspaceId,
  });

  if (error) throw error;
  return (data ?? []) as UnreadInboxPreviewRow[];
}
